import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import TableSkeleton from "../../../Utils/TableSkeleton";
import { getData, Postdata } from "../../../API/GlobalApi";
import Notifier from "../../../Utils/notify";
import "../../../assets/css/StudentShortDetails.css";
import { formatDate } from "../../../Utils/data&dateTime";

const ScheduleFeeApprovalsTemplateCourseWise = () => {
    const { uniqueId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const signature = queryParams.get("signature");
    const user_id = queryParams.get("user_id");
    const navigate = useNavigate();

    const [data, setData] = useState([]);
        const [courses, setCourses] = useState([]);
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openCourseIndex, setOpenCourseIndex] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);
    const getFeePlanData = async () => {
        setLoading(true);
        try {
            if (!uniqueId) return;

            const params = new URLSearchParams();
            params.append("search", uniqueId);
            if (signature) params.append("signature", signature);
            if (user_id) params.append("user_id", user_id);

            const res = await getData(`finance/course-fee-schedule-by-unique-id/?${params.toString()}`);
          

            const responseData = res?.unique_id_batches || [];
            setData(responseData);

            const allCourses =
                res?.unique_id_batches?.flatMap((b) => b.courses) || [];
            setCourses(allCourses);
            setSummary(res.summary || null);
        } catch (error) {
            console.error(error);
            Notifier.error("Failed to fetch fee plan data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFeePlanData();
    }, [uniqueId, signature, user_id]);

    const handleApproval = async () => {
        try {
            const url = `finance/verify-ledger-schedule/?signature=${encodeURIComponent(signature)}&user_id=${encodeURIComponent(user_id)}`;
            const payload = { unique_id: uniqueId };
            const response = await Postdata(url, payload);

            if (response.error) {
                Notifier.error(response.error);
                return;
            }
            navigate("/fee-approval-success", { state: { type: "schedule" } });
        } catch (error) {
            console.error(error);
            Notifier.error("Something went wrong while approving the fee plan");
        }
    };

    const handleCancel = async () => {
        try {
            const url = `finance/reject-student-ledger-and-schedule/?signature=${encodeURIComponent(signature)}&user_id=${encodeURIComponent(user_id)}`;
            const payload = { unique_id: uniqueId };
            const response = await Postdata(url, payload);
            if (response.error) {
                Notifier.error(response.error);
                return;
            }
            Notifier.success("Fee plan rejected successfully!");
            navigate("/fee-approval-cancel");
        } catch (error) {
            console.error(error);
            Notifier.error("Something went wrong while rejecting the fee plan");
        }
    };

    if (loading)
        return (
            <div className="container d-flex justify-content-center align-items-center vh-100">
                <TableSkeleton />
            </div>
        );

    if (!data.length)
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 text-danger text-center impose-responsive-font">
                No fee plan details found for ID: {uniqueId}
            </div>
        );

    return (
        <div className="container py-4 impose-responsive-font">
            <h2 className="text-center mt-5 mb-4 templateFeeTitles">
                Fee Schedule - Course Wise
            </h2>

            {/* 🔹 Summary Section */}
            {summary && (
                <div
                    className="summary-card bg-light p-3 rounded mb-4"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "500",
                    }}
                >
                    <div style={{ flex: "1", minWidth: "200px" }}>
                      
                        <strong>Total Courses:</strong> {summary.total_courses}
                    </div>
                    <div style={{ flex: "1", minWidth: "200px" }}>
                        <strong>Total Students:</strong> {summary.total_students}
                    </div>
                    <div style={{ flex: "1", minWidth: "200px" }}>
                        <strong>Total Amount:</strong> ₹
                        {summary.total_amount_scheduled?.toFixed(2)}
                    </div>
                    {/* <div style={{ flex: "1", minWidth: "200px" }}>
                        <strong>Total Batches:</strong> {summary.total_batches_overall}
                    </div> */}
                </div>
            )}

            {/* 🔹 Main Data */}
          {courses.map((course, idx) => (
                <div key={idx} className="mb-4 border rounded p-3">
                    {/* Accordion Header */}
                    <div
                        className="accordion-header d-flex justify-content-between align-items-center p-3 bg-light border rounded"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                            setOpenIndex(openIndex === idx ? null : idx)
                        }
                    >
                        <div>
                            <h5 className="mb-1">
                                {course.course_name} ({course.academic_year})
                            </h5>
                            <div className="text-muted small">
                                Students: {course.course_total_students} | Total: ₹
                                {course.course_total_amount?.toFixed(2)}
                            </div>
                        </div>
                        <span style={{ color: "#7F56DA", fontSize: "15px" }}>
                            {openIndex === idx ? "▲" : "▼"}
                        </span>
                    </div>

                    {/* Accordion Body */}
                    {openIndex === idx && (
                        <div className="mt-3">
                            {course.fee_heads?.map((feeHead, fhIdx) => (
                                <div key={fhIdx} className="mb-4">
                                    <h6 className="fw-bold mb-2">
                                        Fee Head: {feeHead.fee_head_name}
                                    </h6>

                                    <div
                                        style={{
                                            maxHeight: "400px",
                                            overflowY: "auto",
                                            overflowX: "auto",
                                            border: "1px solid #dee2e6",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        <table
                                            className="table table-bordered text-center mb-0"
                                            style={{ minWidth: "900px" }}
                                        >
                                            <thead>
                                                <tr
                                                    style={{
                                                        position: "sticky",
                                                        top: 0,
                                                        background: "#f8f9fa",
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <th>#</th>
                                                    <th className="text-start">Student Name</th>
                                                    <th className="text-start">Registration</th>
                                                    <th className="text-start">Due Date</th>
                                                    <th className="text-end">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {feeHead.students?.map((stu, sIdx) => (
                                                    <tr key={`${fhIdx}-${sIdx}`}>
                                                        <td>{sIdx + 1}</td>
                                                        <td className="text-start">
                                                            {stu.student_name}
                                                        </td>
                                                        <td className="text-start">
                                                            {stu.student_registration}
                                                        </td>
                                                        <td className="text-start">
                                                            {stu?.due_date
                                                                ? formatDate(
                                                                      new Date(stu.due_date)
                                                                  )
                                                                : "-"}
                                                        </td>
                                                        <td className="text-end">
                                                            ₹{stu.amount?.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}


            {/* Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-4">
                <button className="add-btn px-4" onClick={handleApproval}>
                    Approve
                </button>
                <button className="btn btn-secondary px-4" onClick={handleCancel}>
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default ScheduleFeeApprovalsTemplateCourseWise;
